import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { frFR } from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Base from "components/Base";
import i18n from "config/i18n/i18n";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import { I18nextProvider } from "react-i18next";
import "./resources/styles/styles.less";

export default function App(): React.ReactElement {
  const theme = createTheme(
    {
      palette: {
        primary: {
          main: "#6B9BAB",
        },
      },
    },
    frFR,
  );

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        <Base />
      </ThemeProvider>
    </I18nextProvider>
  );
}
